/**
 * Mirrors the address check behind PhishingManager's getInvalidEmails so both
 * recipient fields accept exactly the same thing.
 */
export const EMAIL_PATTERN = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

/** Commas, semicolons and any whitespace separate one pasted address from the next. */
export const EMAIL_SPLIT_PATTERN = /[,;\s]+/;

/** Keys that turn the typed address into a chip. */
export const COMMIT_KEYS = ['Enter', 'Tab', ',', ' '];

export const ERROR_FLASH_MS = 400;
export const DUPLICATE_FLASH_MS = 600;
